"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileTypes = exports.fileTypeMap = exports.getFileTypeByExtension = exports.fileTypeSchemaDef = exports.fileTypeDataSchemaDef = exports.FileTypeName = exports.FileSize = void 0;
const joi_1 = __importDefault(require("joi"));
const schemaValidator_1 = require("../util/schemaValidator");
var FileSize;
(function (FileSize) {
    FileSize[FileSize["25GB"] = 26843545600] = "25GB";
    FileSize[FileSize["15MB"] = 15728640] = "15MB";
})(FileSize = exports.FileSize || (exports.FileSize = {}));
var FileTypeName;
(function (FileTypeName) {
    FileTypeName["VIDEO"] = "Video";
    FileTypeName["AUDIO"] = "Audio";
    FileTypeName["DATA"] = "Data";
    FileTypeName["PRESENTATION"] = "Presentation";
    FileTypeName["IMAGE"] = "Image";
    FileTypeName["WEB"] = "Web";
    FileTypeName["DOCUMENT"] = "Document";
    FileTypeName["COMPRESSION"] = "Compression";
    FileTypeName["WORD_DOCUMENT_ONLY"] = "Word document only";
    FileTypeName["CSV_DOCUMENT_ONLY"] = "CSV document";
})(FileTypeName = exports.FileTypeName || (exports.FileTypeName = {}));
exports.fileTypeDataSchemaDef = {
    formats: (0, schemaValidator_1.arraySchema)(joi_1.default.string()).default([]),
    sizeLimit: joi_1.default.number().required(),
};
exports.fileTypeSchemaDef = Object.assign(Object.assign({}, exports.fileTypeDataSchemaDef), { name: joi_1.default.string()
        .valid(...Object.values(FileTypeName))
        .required() });
const getFileTypeByExtension = (extension) => {
    let formattedExtension = extension;
    if (!formattedExtension.startsWith('.')) {
        formattedExtension = `.${formattedExtension}`;
    }
    const matchedFileType = Object.values(exports.fileTypeMap).find((fileType) => {
        return fileType.formats.includes(formattedExtension);
    });
    return matchedFileType === null || matchedFileType === void 0 ? void 0 : matchedFileType.name;
};
exports.getFileTypeByExtension = getFileTypeByExtension;
exports.fileTypeMap = {
    [FileTypeName.VIDEO]: {
        name: FileTypeName.VIDEO,
        formats: [
            '.3g2',
            '.3gp',
            '.avi',
            '.flv',
            '.m4v',
            '.mkv',
            '.mov',
            '.mp4',
            '.mp4v',
            '.wmp',
            '.wmv',
            '.wlmp',
            '.mts',
            '.mov-1',
            '.mp4-1',
            '.xspf',
            '.mod',
            '.mpg',
            '.wmf',
        ],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.AUDIO]: {
        name: FileTypeName.AUDIO,
        formats: ['.3g2', '.3ga', '.aac', '.aiff', '.amr', '.m4a', '.m4b', '.m4p', '.mp3', '.wav'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.DATA]: {
        name: FileTypeName.DATA,
        formats: ['.xls', '.xlsx', '.mdb', '.accdb', '.xlsb'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.PRESENTATION]: {
        name: FileTypeName.PRESENTATION,
        formats: ['.ppt', '.pptx', '.pdf', '.gslides', '.pptm', '.odp', '.ink', '.potx', '.pub'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.IMAGE]: {
        name: FileTypeName.IMAGE,
        formats: ['.png', '.jpg', '.jpeg', '.tif', '.tiff', '.jfif', '.gif', '.heic', '.psd', '.dox', '.pcx', '.bmp'],
        sizeLimit: FileSize['15MB'],
    },
    [FileTypeName.WEB]: {
        name: FileTypeName.WEB,
        formats: ['.html', '.htm', '.gdoc', '.url', '.exe', '.key'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.DOCUMENT]: {
        name: FileTypeName.DOCUMENT,
        formats: ['.odt', '.pdf', '.rtf', '.txt', '.doc', '.docx', '.dotx', '.pages'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.COMPRESSION]: {
        name: FileTypeName.COMPRESSION,
        formats: ['.zip', '.zipx', '.zz', '.rar', '.7z', '.tar', '.tar.gz', '.tgz', '.gz'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.WORD_DOCUMENT_ONLY]: {
        name: FileTypeName.WORD_DOCUMENT_ONLY,
        formats: ['.docx'],
        sizeLimit: FileSize['25GB'],
    },
    [FileTypeName.CSV_DOCUMENT_ONLY]: {
        name: FileTypeName.CSV_DOCUMENT_ONLY,
        formats: ['.csv'],
        sizeLimit: FileSize['15MB'],
    },
};
exports.fileTypes = Object.values(exports.fileTypeMap);
